export function switchCase<T = any, U = any>(cases: T[], returnValues: U[], value: T, defaultValue: U = null): U {
  for (const [index, _case] of cases.entries()) {
    if (value === _case) {
      return returnValues[index];
    }
  }

  return defaultValue;
}
